export const MENU_OFFSET = 100;
export const EMAIL_URL = 'mailto:marianazambarda.contact@gmail.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/mariana-zambarda-93a240191/';
export const GITHUB_URL = 'https://github.com/marizambarda';
